export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 24,
    paddingBottom: 24,
    backgroundColor: '#ffffff',
    borderRadius: 8,
    boxShadow: '0px 4px 16px rgba(39, 55, 84, 0.1)',
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
    fontFamily: "'Proxima Nova Alt', sans-serif",
    marginBottom: 20,
    color: '#011533',
  },
  selectorContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  selectTitle: {
    color: 'black',
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    marginRight: 40,
  },
  button: {
    color: '#004360',
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    marginRight: 40,
    fontWeight: '700',
    '&:hover': {
      opacity: '0.6',
      cursor: 'pointer',
    },
  },
  selector: {
    marginRight: 20,
  },

  select: {
    height: 30,
    border: '1px solid gray',
    padding: 10,
    borderRadius: 4,
    '& .MuiSelect-root': {
      backgroundColor: 'transparent',
    },
  },
  error: {
    color: '#004360',
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    marginRight: 40,
    fontWeight: '700',
  },
}
